import { Component, ComponentInterface, Host, Prop, h } from "@stencil/core";

import { fixIEShadowDom } from "../../../../../utils/fix-ie-shadow-dom";

@Component({
    tag: "c-bubble",
    styleUrl: "c-bubble.scss",
})
export class CBubble implements ComponentInterface {
    @Prop() text: string;
    @Prop() variant: "user" | "bot" | "timeout" | "loading";
    // Needed for aria-describedby in feedback component
    @Prop() bubbleId: string;
    @Prop() withFeedback?: boolean;

    variantSwitch = (variant) => {
        switch (variant) {
            case "timeout" : {
                return (
                    <section class="timeout" aria-hidden="true"
                        innerHTML={fixIEShadowDom(this.text, "c-bubble")}>
                    </section>
                )
            }
            case "loading" : {
                return (
                    <section class="loading" aria-hidden="true">
                        <span>.</span>
                        <span>.</span>
                        <span>.</span>
                    </section>
                )
            }
            case "user" : {
                return (
                    <section
                        id="user-bubble"
                        class="user"
                        innerHTML={fixIEShadowDom(this.text, "c-bubble")}
                    ></section>
                )
            }
            case "bot" : {
                return (
                    <div
                        class={
                            this.withFeedback
                                ? "bubble-container-with-feedback"
                                : ""
                        }
                    >
                        <section
                            id={this.bubbleId}
                            class={`bot ${this.withFeedback ? "bubble-with-feedback" : ""
                                }`}
                            innerHTML={fixIEShadowDom(this.text, "c-bubble")}
                        ></section>
                        {this.withFeedback && (
                            <c-feedback bubbleId={this.bubbleId}></c-feedback>
                        )}
                    </div>
                )
            }
        }
    }

    render() {
        return (
            <Host>
                {this.variantSwitch(this.variant)}
            </Host>
        );
    }
}
